export const GET_ALL_CONTACT_TYPES = 'GET_ALL_CONTACT_TYPES'
export const GET_ALL_CONTACT_FILTERS = 'GET_ALL_CONTACT_FILTERS'
export const CHANGE_SWITCH = 'CHANGE_SWITCH'
export const CHANGE_SWITCH_DB = 'CHANGE_SWITCH_DB'
export const GET_ALL_CONTACT_FILTERS_DB = 'GET_ALL_CONTACT_FILTERS_DB'
export const CHANGE_FILTERS_VALUES = 'CHANGE_FILTERS_VALUES'
export const ADD_CONTACT_FILTER_TYPE = 'ADD_CONTACT_FILTER_TYPE'
export const SET_OPTIONS = 'SET_OPTIONS'
export const SET_USERS_OPTIONS = 'SET_USERS_OPTIONS'
export const SET_FILTERS_VALUES_ON_LOAD = 'SET_FILTERS_VALUES_ON_LOAD'
export const REMOVE_FILTERS_VALUES = 'REMOVE_FILTERS_VALUES'
export const REMOVE_FILTER = 'REMOVE_FILTER'
export const CLEAR_FILTERS = 'CLEAR_FILTERS'
